export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7826.49e63913.jpg";